export default __webpack_public_path__ + "static/media/workspace-role-type-icon.7a22be24.svg";